module.exports = __webpack_public_path__ + "static/img/IMG_20151223_190703.1578c289.jpg";